
















































import Vue from 'vue';
import { UserClient } from '@/assets/src/clients/user_client';
import { SearchParameter } from '@/assets/src/search_parameter';
import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'FindUser',

  methods: {
    async findUser() {
      if (!this.userClient) {
        return;
      }

      this.users = await this.userClient.findUser([new SearchParameter(this.searchKey, this.searchValue)]);
    },
  },

  mounted() {
    this.userClient = new UserClient();
  },

  data() {
    return {
      users: [] as any[],
      userClient: null as UserClient | null,

      searchKey: 'email',
      searchValue: '',
    };
  },

  routeNames: ROUTE_NAMES,
});
